/**
 * Delivery zone map – Leaflet visualization of postal code coverage.
 * Requires Leaflet (loaded by section) and delivery-zones.json.
 */
(function () {
  'use strict';

  var ZONE_COLORS = {
    0: '#2d6a4f',
    375: '#52b788',
    575: '#f4a261',
    750: '#e76f51'
  };

  var maps = {};

  function digitsOnly(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function findPoint(points, postalCode) {
    var code = parseInt(digitsOnly(postalCode), 10);
    if (!code) return null;

    for (var i = 0; i < points.length; i++) {
      if (points[i].p === code) return points[i];
    }
    return null;
  }

  function initDeliveryMap(container) {
    if (!container || maps[container.id]) return;
    if (typeof L === 'undefined') {
      setTimeout(function () { initDeliveryMap(container); }, 100);
      return;
    }

    var dataUrl = container.getAttribute('data-zones-url');
    if (!dataUrl) return;

    fetch(dataUrl)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        renderMap(container, data);
      })
      .catch(function (err) {
        console.warn('Delivery map: could not load zones', err);
        container.classList.add('delivery-map__canvas--error');
        container.innerHTML = '<p class="delivery-map__error">Kartan kunde inte laddas.</p>';
      });
  }

  function renderMap(container, data) {
    var bounds = data.meta.bounds;
    var map = L.map(container, {
      scrollWheelZoom: false,
      zoomControl: true,
      attributionControl: true
    });

    maps[container.id] = { map: map, points: data.points, marker: null };

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &middot; GeoNames'
    }).addTo(map);

    var canvasRenderer = L.canvas({ padding: 0.5 });
    var layer = L.layerGroup().addTo(map);

    data.points.forEach(function (pt) {
      L.circleMarker([pt.lat, pt.lng], {
        renderer: canvasRenderer,
        radius: 4,
        fillColor: ZONE_COLORS[pt.f] || '#999',
        fillOpacity: 0.55,
        stroke: false
      }).addTo(layer);
    });

    map.fitBounds([
      [bounds.south, bounds.west],
      [bounds.north, bounds.east]
    ], { padding: [24, 24] });

    container._deliveryMapInstance = maps[container.id];

    var saved = typeof getDeliveryInfo === 'function' ? getDeliveryInfo() : null;
    if (saved && saved.valid) {
      highlightPostal(container.id, saved.postalCode, saved);
    }

    window.dispatchEvent(new CustomEvent('vedbiten:delivery-map-ready', {
      detail: { containerId: container.id }
    }));
  }

  function highlightPostal(containerId, postalCode, info) {
    var instance = maps[containerId];
    if (!instance) return;

    var point = findPoint(instance.points, postalCode);
    var map = instance.map;

    if (instance.marker) {
      map.removeLayer(instance.marker);
      instance.marker = null;
    }

    if (!point) {
      map.closePopup();
      return;
    }

    var zoneName = info && info.zone ? info.zone : '';
    var price = info && typeof info.price === 'number' ? info.price : point.f;
    var priceText = price === 0 ? 'Fri frakt' : price + ' kr';

    instance.marker = L.circleMarker([point.lat, point.lng], {
      radius: 12,
      fillColor: ZONE_COLORS[point.f] || '#2d6a4f',
      fillOpacity: 1,
      color: '#fff',
      weight: 3
    }).addTo(map);

    instance.marker.bindPopup(
      '<strong>' + (info && info.postalCode ? info.postalCode : formatPostalCodeSafe(postalCode)) + '</strong><br>' +
      (point.c || '') + '<br>' +
      zoneName + ' &middot; ' + priceText
    ).openPopup();

    map.setView([point.lat, point.lng], Math.max(map.getZoom(), 11), { animate: true });
  }

  function formatPostalCodeSafe(value) {
    if (typeof formatPostalCode === 'function') {
      return formatPostalCode(value);
    }
    var d = digitsOnly(value);
    return d.length > 3 ? d.slice(0, 3) + ' ' + d.slice(3) : d;
  }

  function onPostalChecked(event) {
    var detail = event.detail;
    if (!detail || !detail.valid) return;

    document.querySelectorAll('.delivery-map__canvas').forEach(function (container) {
      if (maps[container.id]) {
        highlightPostal(container.id, detail.postalCode, detail);
      } else {
        container._pendingHighlight = detail;
      }
    });
  }

  function onMapReady(event) {
    var containerId = event.detail && event.detail.containerId;
    if (!containerId) return;

    var container = document.getElementById(containerId);
    if (container && container._pendingHighlight) {
      var detail = container._pendingHighlight;
      highlightPostal(containerId, detail.postalCode, detail);
      delete container._pendingHighlight;
    }
  }

  function boot() {
    document.querySelectorAll('.delivery-map__canvas').forEach(initDeliveryMap);
    window.addEventListener('vedbiten:postal-checked', onPostalChecked);
    window.addEventListener('vedbiten:delivery-map-ready', onMapReady);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
